/* Gruppo Quinta Strada · sito
   menu (con la tendina dei 5 store), intestazione che si fa da parte, comparse, numeri che contano,
   profondità leggera, fisarmoniche, banner cookie. Un solo ascoltatore di scorrimento, con requestAnimationFrame. */
(function () {
  "use strict";
  var doc = document, body = doc.body, win = window;
  var calma = win.matchMedia("(prefers-reduced-motion: reduce)");
  var header = doc.getElementById("header");

  /* ── menu da telefono ─────────────────────────────────── */
  var menuBtn = doc.querySelector(".menu-btn");
  var nav = doc.getElementById("menu");
  function chiudiMenu() {
    if (!nav || !menuBtn) return;
    nav.classList.remove("is-open");
    body.classList.remove("menu-aperto");
    menuBtn.setAttribute("aria-expanded", "false");
    menuBtn.setAttribute("aria-label", "Apri il menu");
  }
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      if (header) {
        header.classList.remove("is-nascosto");
        nav.style.setProperty("--menu-top", Math.round(header.getBoundingClientRect().bottom) + "px");
      }
      var aperto = nav.classList.toggle("is-open");
      body.classList.toggle("menu-aperto", aperto);
      menuBtn.setAttribute("aria-expanded", aperto ? "true" : "false");
      menuBtn.setAttribute("aria-label", aperto ? "Chiudi il menu" : "Apri il menu");
    });
    nav.addEventListener("click", function (e) { if (e.target.closest("a")) chiudiMenu(); });
    doc.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("is-open")) { chiudiMenu(); menuBtn.focus(); }
    });
    win.matchMedia("(min-width: 1001px)").addEventListener("change", function (m) { if (m.matches) chiudiMenu(); });
  }

  /* ── la tendina degli store (da computer): «Store» e il pulsante dell'header la aprono; col mouse si apre passando.
     Da telefono la stessa lista sta nel menu a tutto schermo, sempre aperta. ── */
  var tendina = doc.getElementById("tendina");
  var voceStore = tendina && tendina.closest(".nav__voce--store");
  var apriT = Array.prototype.slice.call(doc.querySelectorAll("[data-tendina]"));
  var computer = win.matchMedia("(min-width: 1001px)");
  var tAttesa = null, tApertaIl = 0, tApertaY = 0;
  function tendinaAperta() { return !!voceStore && voceStore.classList.contains("is-open"); }
  function setTendina(apri) {
    if (!voceStore) return;
    win.clearTimeout(tAttesa);
    if (apri && !tendinaAperta()) { tApertaIl = Date.now(); tApertaY = win.scrollY; }
    voceStore.classList.toggle("is-open", apri);
    apriT.forEach(function (b) { b.setAttribute("aria-expanded", apri ? "true" : "false"); });
  }
  if (voceStore) {
    apriT.forEach(function (b) {
      b.addEventListener("click", function (e) {
        if (!computer.matches) return;
        e.preventDefault();
        if (tendinaAperta() && Date.now() - tApertaIl < 500) return;   // appena aperta passandoci sopra: resta aperta
        var apri = !tendinaAperta();
        setTendina(apri);
        if (apri && e.detail === 0) { var l = tendina.querySelector("a"); if (l) l.focus(); }   // da tastiera: dentro
      });
    });
    if (win.matchMedia("(hover: hover)").matches) {
      voceStore.addEventListener("mouseenter", function () {
        if (!computer.matches) return;
        win.clearTimeout(tAttesa);
        tAttesa = win.setTimeout(function () { setTendina(true); }, 90);
      });
      voceStore.addEventListener("mouseleave", function () {
        if (!computer.matches) return;
        win.clearTimeout(tAttesa);
        tAttesa = win.setTimeout(function () { setTendina(false); }, 240);
      });
    }
    doc.addEventListener("click", function (e) {
      if (tendinaAperta() && !e.target.closest(".nav__voce--store") && !e.target.closest("[data-tendina]") && !e.target.closest("[data-apri-store]")) setTendina(false);
    });
    doc.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && tendinaAperta()) { setTendina(false); var b = doc.querySelector(".nav__store"); if (b) b.focus(); }
    });
    voceStore.addEventListener("focusout", function (e) {
      var r = e.relatedTarget;
      if (computer.matches && tendinaAperta() && r && !voceStore.contains(r) && !(r.closest && r.closest("[data-tendina]"))) setTendina(false);
    });
    computer.addEventListener("change", function () { setTendina(false); });
  }

  /* ── i link «Scegli lo store», «Guarda gli store»… nel corpo delle pagine: aprono la tendina «Gli store» come il
     pulsante dell'header; da telefono il menu a tutto schermo, che ha i cinque store in testa. Senza JS: la home. ── */
  doc.addEventListener("click", function (e) {
    var a = e.target.closest("[data-apri-store]");
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (header) header.classList.remove("is-nascosto");
    if (computer.matches && voceStore) {
      setTendina(true);
      if (e.detail === 0) { var l = tendina.querySelector("a"); if (l) l.focus(); }
    } else if (menuBtn && nav && !nav.classList.contains("is-open")) {
      menuBtn.click();
    }
  });

  /* ── ancore interne: scorrimento morbido, con l'intestazione in vista all'arrivo ── */
  var bloccaFinoA = 0;
  doc.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.hasAttribute("data-apri") || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    var id = a.getAttribute("href").slice(1);
    var meta = id && doc.getElementById(id);
    if (!meta) return;
    e.preventDefault();
    bloccaFinoA = Date.now() + 1200;
    if (header) header.classList.remove("is-nascosto");
    meta.scrollIntoView({ behavior: calma.matches ? "auto" : "smooth", block: "start", inline: "start" });
    if (history.pushState) history.pushState(null, "", "#" + id);
    if (id === "contenuto") meta.focus({ preventScroll: true });
  });

  /* ── un solo ascoltatore di scorrimento ─────────────────
     · intestazione: ombra appena si scorre; si fa da parte scendendo, torna risalendo
     · profondità: la foto della hero e il «2004» grande scorrono un po' più lenti */
  var heroFoto = doc.querySelector(".hero__foto");
  var heroPic = heroFoto && heroFoto.querySelector("picture");
  var numero = doc.querySelector(".storia__numero");
  var telefono = win.matchMedia("(max-width: 1000px)");   // come il CSS: fino a 1000 px la linea è verticale
  var ultimoY = win.scrollY, inAttesa = false;

  function profondita() {
    if (calma.matches) {
      if (heroPic) heroPic.style.transform = "";
      if (numero) numero.style.transform = "";
      return;
    }
    var vh = win.innerHeight;
    if (heroPic) {
      var r = heroFoto.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) {
        if (telefono.matches) {
          // la foto sta sotto il testo: si muove dentro la sua cornice
          var c = (r.top + r.height / 2 - vh / 2) * -0.07;
          heroPic.style.transform = "translate3d(0," + c.toFixed(1) + "px,0) scale(1.1)";
        } else {
          // dalla posizione del design (y = 0) scende più lenta; la scala copre il bordo alto
          var k = 0.16, y = Math.max(0, win.scrollY) * k, sc = 1 + (2 * y) / r.height;
          heroPic.style.transform = "translate3d(0," + y.toFixed(1) + "px,0) scale(" + sc.toFixed(4) + ")";
        }
      } else {
        heroPic.style.transform = "";
      }
    }
    if (numero) {
      var n = numero.getBoundingClientRect();
      if (n.bottom > -200 && n.top < vh + 200) {
        var d = (n.top + n.height / 2 - vh / 2) * (telefono.matches ? -0.06 : -0.14);
        d = Math.max(-26, Math.min(26, d));
        numero.style.transform = "translate3d(0," + d.toFixed(1) + "px,0)";
      }
    }
  }

  function aggiorna() {
    inAttesa = false;
    var y = win.scrollY;
    if (header) {
      header.classList.toggle("is-scrolled", y > 60);
      var menuAperto = body.classList.contains("menu-aperto");
      if (tendinaAperta() && Math.abs(y - tApertaY) > 140) setTendina(false);
      if (Date.now() < bloccaFinoA || menuAperto || tendinaAperta() || y < 320) {
        header.classList.remove("is-nascosto");
      } else if (y > ultimoY + 6) {
        header.classList.add("is-nascosto");
      } else if (y < ultimoY - 6) {
        header.classList.remove("is-nascosto");
      }
    }
    ultimoY = y;
    profondita();
  }
  win.addEventListener("scroll", function () {
    if (!inAttesa) { inAttesa = true; win.requestAnimationFrame(aggiorna); }
  }, { passive: true });
  win.addEventListener("resize", function () {
    if (!inAttesa) { inAttesa = true; win.requestAnimationFrame(aggiorna); }
  });
  aggiorna();

  /* ── i numeri che contano: 5, 8, 3 da zero; il 2004 torna indietro da oggi ── */
  function conta(el) {
    var fine = parseInt(el.getAttribute("data-conta"), 10);
    var inizio = parseInt(el.getAttribute("data-da") || "0", 10);
    if (calma.matches || isNaN(fine)) return;
    var durata = Math.abs(fine - inizio) > 10 ? 1500 : 1100;
    var t0 = null;
    el.textContent = inizio;
    function passo(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / durata);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(inizio + (fine - inizio) * e);
      if (p < 1) win.requestAnimationFrame(passo); else el.textContent = fine;
    }
    win.requestAnimationFrame(passo);
  }

  /* ── comparse allo scorrimento ────────────────────────── */
  var reveals = win.qsComparse ? [] : doc.querySelectorAll(".reveal");
  function mostra(el) {
    el.classList.add("in");
    var n = el.querySelector("[data-conta]");
    if (n) win.setTimeout(function () { conta(n); }, 120 + (parseInt(el.style.getPropertyValue("--i"), 10) || 0) * 90);
  }
  if ("IntersectionObserver" in win && !calma.matches) {
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) { mostra(v.target); io.unobserve(v.target); }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  /* ── fisarmoniche (città dei negozi e domande frequenti): morbide, una aperta alla volta ── */
  function fisarmonica(selVoce, selCorpo) {
    var voci = Array.prototype.slice.call(doc.querySelectorAll(selVoce));
    function anima(d, apri) {
      var corpo = d.querySelector(selCorpo);
      if (!corpo || calma.matches || !corpo.animate) { d.open = apri; return; }
      if (d._anim) d._anim.cancel();
      if (apri) d.open = true;
      var h = corpo.scrollHeight;
      var a = corpo.animate(
        apri ? [{ height: "0px", opacity: 0 }, { height: h + "px", opacity: 1 }]
             : [{ height: h + "px", opacity: 1 }, { height: "0px", opacity: 0 }],
        { duration: apri ? 420 : 300, easing: "cubic-bezier(.16,1,.3,1)" }
      );
      d._anim = a;
      a.onfinish = function () { d._anim = null; if (!apri) d.open = false; };
    }
    voci.forEach(function (d) {
      d.querySelector("summary").addEventListener("click", function (e) {
        e.preventDefault();
        var apri = !d.open;
        if (apri) voci.forEach(function (altra) { if (altra !== d && altra.open) anima(altra, false); });
        anima(d, apri);
      });
    });
  }
  fisarmonica(".citta__voce", ".citta__negozi");
  fisarmonica(".faq", ".faq__risposta");

  /* ── la linea Quinta Strada: il treno parte dalla «Q» e si ferma a ogni fermata (2 Step, 13/10/2026) ──
     Le posizioni si misurano sulle fermate vere, così vale da computer (in orizzontale) e da telefono (in verticale)
     e anche con una fermata in più. Si muove solo quando la linea si vede; con «riduci movimento» resta fermo
     alla prima fermata. */
  var telefono = win.matchMedia("(max-width: 1000px)");   // come il CSS: fino a 1000 px la linea è verticale
  doc.querySelectorAll("[data-linea]").forEach(function (linea) {
    var treno = linea.querySelector("[data-treno]");
    var tracciato = linea.querySelector(".tracciato");
    var q = linea.querySelector(".linea__q");
    if (!treno || !tracciato || !treno.animate) return;
    var anim = null, vista = false, attesa = 0;
    function centri() {
      var b = tracciato.getBoundingClientRect(), vert = telefono.matches;
      function c(el) {
        var r = el.getBoundingClientRect();
        return vert ? r.top + r.height / 2 - b.top : r.left + r.width / 2 - b.left;
      }
      return { vert: vert, partenza: q ? c(q) : 0, fermate: [].map.call(linea.querySelectorAll(".punto"), c) };
    }
    function avvia() {
      if (anim) { anim.cancel(); anim = null; }
      var m = centri(), lato = m.vert ? "top" : "left", altro = m.vert ? "left" : "top";
      treno.style[altro] = "";
      if (!m.fermate.length) return;
      if (calma.matches) { treno.style[lato] = m.fermate[0] + "px"; treno.style.opacity = 1; return; }
      if (!vista) return;
      var n = m.fermate.length, passo = 1 / (n + 1.6), sosta = passo * 0.45, fr = [];
      fr.push({ offset: 0, opacity: 0 }); fr[0][lato] = m.partenza + "px";
      var t = passo * 0.6;
      m.fermate.forEach(function (x, i) {
        var arrivo = { offset: t, opacity: 1, easing: "cubic-bezier(.45,0,.2,1)" }; arrivo[lato] = x + "px";
        if (i === 0) { var esce = { offset: passo * 0.12, opacity: 1, easing: "cubic-bezier(.45,0,.2,1)" }; esce[lato] = m.partenza + "px"; fr.push(esce); }
        fr.push(arrivo);
        var ferma = { offset: Math.min(t + sosta, 0.97), opacity: 1, easing: "cubic-bezier(.45,0,.2,1)" }; ferma[lato] = x + "px";
        fr.push(ferma);
        t += passo;
      });
      var resta = { offset: 0.955, opacity: 1 }; resta[lato] = m.fermate[n - 1] + "px"; fr.push(resta);
      var fine = { offset: 0.985, opacity: 0 }; fine[lato] = m.fermate[n - 1] + "px"; fr.push(fine);
      var ultimo = { offset: 1, opacity: 0 }; ultimo[lato] = m.partenza + "px"; fr.push(ultimo);
      anim = treno.animate(fr, { duration: n * 2300, iterations: Infinity });
    }
    function rifai() { win.clearTimeout(attesa); attesa = win.setTimeout(avvia, 180); }
    if ("IntersectionObserver" in win) {
      new IntersectionObserver(function (v) {
        vista = v[0].isIntersecting;
        if (vista && !anim) avvia(); else if (anim) { vista ? anim.play() : anim.pause(); }
      }, { threshold: 0.2 }).observe(linea);
    } else { vista = true; }
    avvia();
    win.addEventListener("resize", rifai);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(rifai);
  });

  /* ── banner cookie: una riga, si chiude e non torna ───── */
  var bar = doc.querySelector(".cookie-bar");
  var CHIAVE = "gqs-cookie-ok";
  var visto = false;
  try { visto = localStorage.getItem(CHIAVE) === "1"; } catch (e) {}
  if (bar && !visto) {
    bar.hidden = false;
    bar.querySelector(".cookie-bar__x").addEventListener("click", function () {
      bar.hidden = true;
      try { localStorage.setItem(CHIAVE, "1"); } catch (e) {}
    });
  }
})();
